export const sortingData = (state) => state.locations.sorting;
